export const SERVICE_STATUS = {
  ACTIVATED: 1,
  UNAVAILABLE: 2,
};
